/* eslint-disable import/prefer-default-export */
import {
  FIELD_END,
  FIELD_SEPARATE_EVENT_PER_TECH,
  FIELD_START,
  FIELD_TECHNICIAN_USERS,
} from 'modules/Event/constants/fields';
import dayjs from 'utils/dayjs';
import getDefaultTimezone from 'utils/timezone/getDefaultTimezone';

export function splitEventPerDayPerUser(values) {
  let perUsers = [];
  const perDates = [];

  if (values[FIELD_SEPARATE_EVENT_PER_TECH]) {
    perUsers = values[FIELD_TECHNICIAN_USERS]?.map((userId) => [userId]);
  } else {
    perUsers = [values[FIELD_TECHNICIAN_USERS]];
  }

  const date1 = dayjs.utc(values[FIELD_END]);
  const diff = date1.diff(dayjs.utc(values[FIELD_START]), 'day');

  const startInitial = dayjs.utc(values[FIELD_START]).tz(getDefaultTimezone());

  if (diff > 0) {
    let start = dayjs.utc(values[FIELD_START]).tz(getDefaultTimezone());
    const end = dayjs.utc(values[FIELD_END]).tz(getDefaultTimezone());

    for (; start.isBefore(end); start = start.add(1, 'day')) {
      perDates.push([
        start.isAfter(startInitial)
          ? start.startOf('day').utc().format()
          : start.utc().format(),
        start.endOf('day').isBefore(end)
          ? start.endOf('day').utc().format()
          : end.utc().format(),
      ]);
    }
  } else {
    perDates.push([values[FIELD_START], values[FIELD_END]]);
  }

  return perUsers.reduce(
    (events, userIds) => [
      ...events,
      ...perDates.map(([start, end]) => ({
        ...values,
        [FIELD_TECHNICIAN_USERS]: userIds,
        [FIELD_START]: start,
        [FIELD_END]: end,
      })),
    ],
    [],
  );
}
